import { Location } from "react-router";

export const getReferrer = (location: Location) => {
  const state = location.state as undefined | { referrer?: string };

  return state?.referrer || "/";
};
